import { api } from "../../utils/api";

export const getLeadMessageMedia = async (leadId, messageId) => {
  try {
    const response = await api.get(`lead/message/${leadId}/${messageId}`);
    return response.data;
  } catch (error) {
    // Parse de erros da API
    let apiMessage = "Erro interno do servidor";
    
    if (error.response?.data?.message) {
      apiMessage = error.response.data.message;
    } else if (error.message) {
      apiMessage = error.message;
    }

    const customError = new Error(apiMessage);
    customError.statusCode = error.response?.status;
    customError.apiMessage = apiMessage;
    
    throw customError;
  }
};
